import { Chip, Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import { GridLabel, GridinRow } from "utils/style";

interface IScheduleTypeProp {
  regularStatus: string;
  ccaStatus: string;
}

const chipStyle = {
  backgroundColor: "#4caf50",
  color: "#FFF",
  marginBottom: "5px",
};

const ScheduleType = ({
  regularStatus,
  ccaStatus
}: IScheduleTypeProp) => {
  return (
    <SanitizedGrid container spacing={2}>
      {regularStatus && regularStatus === "active" && <Chip label="Regular" style={chipStyle} />}

      {ccaStatus && ccaStatus === "active" && <Chip label="CCA" style={chipStyle} />}

      {(!regularStatus || regularStatus === "inactive") &&
        (!ccaStatus || ccaStatus === "inactive") &&
        (
          <Grid item xs={12} style={GridinRow}>
            <Typography variant="body2" style={GridLabel}>
              -
            </Typography>
          </Grid>
        )
      }
    </SanitizedGrid>
  );
};

export default ScheduleType;
